import script from "./ImportKaigoNoMoriStaff.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportKaigoNoMoriStaff.vue?vue&type=script&setup=true&lang=js"

import "./ImportKaigoNoMoriStaff.vue?vue&type=style&index=0&id=2196101e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2196101e"]])

export default __exports__